import { render, staticRenderFns } from "./save-query.vue?vue&type=template&id=2a8c2cf0&scoped=true&"
import script from "./save-query.vue?vue&type=script&lang=js&"
export * from "./save-query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c2cf0",
  null
  
)

export default component.exports